import gql from 'graphql-tag';

const RESOURCE_TYPE_FRAGMENT = gql`
  fragment BaseResourceType on ResourceType {
    id
    type
    title
    description
    sortIndex
  }
`;

export default RESOURCE_TYPE_FRAGMENT;
